import React, { useRef } from "react";
import { Paper } from "@mui/material";
import SelectShareButton from "../SelectShareButton/SelectShareButton";
import SelectionActionsBar from "./SelectionActionsBar";
import useParentOverflow from "../../hooks/useParentOverflow";

const footerSx = {
  display: "flex",
  justifyContent: "end",
  alignItems: "center",
  backgroundColor: "#e2e4ff",
  padding: "16px",
  position: "sticky",
  bottom: "16px",
  left: 0,
  right: 0,
  zIndex: 5,
  borderRadius: "4px",
  marginLeft: "46px",
  marginRight: "46px",
  boxShadow:
    "0px 3px 5px -1px rgba(88,98,125,0.2), 0px 6px 10px 0px rgba(88,98,125,0.2), 0px 1px 18px 0px rgba(88,98,125,0.1)",
};

const noScrollSx = {
  marginLeft: 0,
  marginRight: 0,
  bottom: 0,
};

const ModalActionsFooter = ({
  isSelectionMode = false,
  selectedCount = 0,
  onCancel,
  onShare,
  onRelease,
  canShare = false,
  canRelease = false,
  selectedFiles = [],
  handleSelectOrShare,
  hasFiles = false,
}) => {
  const rootRef = useRef(null);
  const { hasOverflow, isAtBottom } = useParentOverflow(rootRef, [
    isSelectionMode,
    hasFiles,
    selectedCount,
  ]);
  const isFloating = hasOverflow && !isAtBottom;

  return (
    <Paper
      ref={rootRef}
      elevation={6}
      sx={[footerSx, !isFloating && noScrollSx]}
    >
      {isSelectionMode ? (
        <SelectionActionsBar
          selectedCount={selectedCount}
          onCancel={onCancel}
          onShare={onShare}
          onRelease={onRelease}
          canShare={canShare}
          canRelease={canRelease}
        />
      ) : (
        <SelectShareButton
          isSelectionMode={false}
          selectedFiles={selectedFiles}
          handleSelectOrShare={handleSelectOrShare}
          hasFiles={hasFiles}
        />
      )}
    </Paper>
  );
};

export default React.memo(ModalActionsFooter);
